import React, { Component } from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import TpSurveyService from '../../../Services/tpSurveyService';
import ErrorMessage from '../../../Elements/ErrorMessage';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import TpSurveyItem from '../../../Domain/TpSurveyItem';
import TpSurveyActivateWindowDescription from './TpSurveyActivateWindowDescription';
import TpSurveySearchParams from './TpSurveySearchParams';
import AssociateTpSurveyPanel from './AssociateTpSurveyPanel';
import ClientTpSurveyItem from '../../../Domain/ClientTpSurveyItem';

export default class TpSurveyAdmin extends Component {
  constructor(props) {
    super(props);

    let newSearchItem;
    if (props.ClientId) {
      newSearchItem = new TpSurveySearchParams(props.ClientId);
    } else {
      newSearchItem = new TpSurveySearchParams();
      if (props.ProjectId) {
        newSearchItem.ProjectId = props.ProjectId;
      }
    }

    this.state = {
      searchItem: newSearchItem,
      shownPanel: ShownPanelsEnum.None,
      selectedItem: null,
    };
    this.editedItem = null;
    this.bindFunctions();
  }

  bindFunctions() {
    this.handleButtonRowButtonClick = this.handleButtonRowButtonClick.bind(this);
    this.refresh = this.refresh.bind(this);
    TpSurveyItem.clickOnDeactivateSurvey = this.clickOnDeactivateSurvey.bind(this);
    TpSurveyItem.clickOnActivateSurvey = this.clickOnActivateSurvey.bind(this);
    TpSurveyItem.removeAssociationFunction = this.removeAssociationFunction.bind(this);
  }

  removeAssociationFunction(id, item, itemList) {
    const edited = { TpSurveyId: item.TpSurveyId, ProjectId: this.props.ProjectId };
    ErrorMessage.SetNotification(
      'The survey removal process started in the background. This might take some time, you will be notified via in-app notification when the process has finished.'
    );
    TpSurveyService.RemoveSurveyAssociation(edited)
      .then((result) => {
        if (result.error) {
          ErrorMessage.SetErrorMessage(result.error);
          return;
        }
        ErrorMessage.SetNotification('Survey removed from project.');
        this.refresh();
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('TWA55', error);
      });

    document.dispatchEvent(
      new KeyboardEvent('keydown', {
        altKey: false,
        code: 'Escape',
        ctrlKey: false,
        isComposing: false,
        key: 'Escape',
        location: 0,
        metaKey: false,
        repeat: false,
        shiftKey: false,
        which: 27,
        charCode: 0,
        keyCode: 27,
      })
    );
  }
  clickOnActivateSurvey(item) {
    this.editedItem = { ...item, IsActivated: true };
    this.setState({ shownPanel: ShownPanelsEnum.AddNewItem });
  }

  clickOnDeactivateSurvey(item) {
    const edited = { ...item, IsActivated: false };
    TpSurveyService.ActivateDeacivateSurvey(edited)
      .then((result) => {
        if (result.errorMessage) {
          ErrorMessage.SetErrorMessage(result.errorMessage);
          return;
        }
        this.refresh();
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('TSA47');
      });
  }

  refresh() {
    this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem } });
  }

  handleButtonRowButtonClick(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  handleClickOnStartSearch(searchItem) {
    return this.setState({ searchItem });
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  showPanel(panelId) {
    if (panelId === ShownPanelsEnum.SomethingElse) {
      this.setState({
        searchItem: {
          ...this.state.searchItem,
          IsActivated: this.state.searchItem.IsActivated === true ? false : true,
        },
      });
      return;
    }
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  renderButtonsAndPanels() {
    return (
      <>
        {!this.props.IsSubClientsView && (
          <FigmaButtonRow
            className={'InnerMenuButtonFigmaList'}
            buttons={[
              {
                iconName:
                  this.state.searchItem.IsActivated === true
                    ? 'fa-solid fa-light-switch-on'
                    : 'fa-solid fa-light-switch-off',
                type: ButtonTypeEnum.NormalIconOnly,
                color:
                  this.state.searchItem.IsActivated === true ? ButtonColorsEnum.Primary : ButtonColorsEnum.Secondary,
                iconPosition: IconPositionEnum.Center,
                onClick: () => this.showPanel(ShownPanelsEnum.SomethingElse),
                tooltip: this.state.searchItem.IsActivated === true ? 'Show deactivated' : 'Show activated',
                roleKey: 'project_edit',
              },
              {
                iconName: 'fa-solid fa-plus-circle',
                type: ButtonTypeEnum.NormalIconOnly,
                color: ButtonColorsEnum.Primary,
                iconPosition: IconPositionEnum.Center,
                onClick: () => this.showPanel(ShownPanelsEnum.AssociateTpSurvey),
                tooltip: 'Associate Third-Party Survey',
                roleKey: 'project_edit',
              },
            ]}
          />
        )}
        {this.renderPanels()}
      </>
    );
  }

  renderAssociateTpSurveyPanel() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.AssociateTpSurvey,
          <AssociateTpSurveyPanel
            clickOnCancel={() => {
              this.setState({ shownPanel: ShownPanelsEnum.None });
            }}
            searchItem={this.state.searchItem}
            isOverWindow={true}
          />
        )}
      </div>
    );
  }

  renderAddNewItemPanel() {
    return this.renderOnePanel(
      ShownPanelsEnum.AddNewItem,
      <GeneralEditWizzardBase
        crudType={CrudTypesEnum.Create}
        editedItem={this.editedItem}
        clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
        clickOnSave={this.refresh}
        windowDescription={TpSurveyActivateWindowDescription}
        errorCode={'TSA111'}
      />
    );
  }

  renderPanels() {
    return (
      <div>
        {this.renderAddNewItemPanel()}
        {this.renderAssociateTpSurveyPanel()}
      </div>
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={this.props.ClientId ? ClientTpSurveyItem : TpSurveyItem}
          serviceFunction={TpSurveyService.GetTpSurveyItemList}
          convertDBItemsFunction={TpSurveyService.ConvertDBItem}
          searchItem={this.state.searchItem}
          searchParamsType={TpSurveySearchParams}
          showSearchStrip={true}
          clickOnStartSearch={(searchItem) => this.handleClickOnStartSearch(searchItem)}
          singleSearchLine={false}
          //isExportExcelDisabled={false}
          //clickOnExportExcel={this.handleExportExcelButtonClick}
          singleSearchLinePlaceholder='Search in TpClientLinkId...'
          errorCode='TCLA99'
          afterClickOnCancel={() => this.bindFunctions()}
          enableUrlPush={false}
          showPagination={true}
        />
      </div>
    );
  }
}
